import { Segment } from '@mairistem/composants';
import { PiecesJointesProvider } from '@mairistem/comptabilite';
import { App, Feature, Menu, SpeedDial } from '@mairistem/module';
import { Viewer } from '@mairistem/piecesjointes';
import { newIdentifiant, request } from '@mairistem/tools';
import * as React from 'react';
import Context from '@/src/components/Context';
import Accueil from '@/src/components/Dashboard/Dashboard';
import Parametres from '@/src/components/Parametres/Parametres';
import AppPlanning from '@/src/components/Planning/Planning';
import ProjetFiche from '@/src/components/ProjetFiche/ProjetFiche';
import ProjetListeContainer from '@/src/components/ProjetListe/ProjetListeContainer';
import SubventionFiche from '@/src/components/SubventionFiche/SubventionFiche';
import SubventionListeContainer from '@/src/components/SubventionListe/SubventionListeContainer';

const AppSubvention = () => {
	const handleOnAuth = async () => {
		const queryParams = new URLSearchParams(window.location.search);
		sessionStorage.setItem(
			'identifiantEntite',
			queryParams.get('identifiantEntite'),
		);
	};

	return (
		<App
			name="Subventions"
			code="HOL_SUBP"
			group="finances"
			context={Context}
			onAuth={handleOnAuth}
			request={request}
			additionalProductCodesUpdate={['HOL_CPTA', '360_SUBP']}
		>
			<Feature path="/:path*/preview/" name="Prévisualisation">
				<Feature.Content>{Viewer}</Feature.Content>
			</Feature>
			<Menu.Home dataTestId="ongletAccueil">
				<Feature name="Accueil">
					<Feature.Content>
						<Segment inverted attached className="feature">
							<Segment>
								<Accueil />
							</Segment>
						</Segment>
					</Feature.Content>
				</Feature>
			</Menu.Home>
			<Menu
				dataTestId="ongletParametre"
				icon="cog"
				name="Paramètres"
				path="/parametres"
			>
				<Feature>
					<Feature.Content>
						<Segment inverted attached className="feature">
							<Segment>
								<Parametres />
							</Segment>
						</Segment>
					</Feature.Content>
				</Feature>
			</Menu>
			<Menu.Separator />
			<Menu
				name="Projets"
				icon="folder open"
				path="/projets"
				dataTestId="ongletProjet"
			>
				<Feature path="/:identifiant">
					<Feature.Content>
						<PiecesJointesProvider>
							<ProjetFiche />
						</PiecesJointesProvider>
					</Feature.Content>
				</Feature>
				<Feature>
					<Feature.Content>
						<Segment
							inverted
							attached
							className="feature projetSubventionListe"
						>
							<Segment>
								<ProjetListeContainer />
							</Segment>
						</Segment>
					</Feature.Content>
				</Feature>
			</Menu>
			<Menu
				name="Subventions"
				icon="money-bill"
				path="/subventionsPercues"
				dataTestId="ongletSubvention"
			>
				<Feature path="/:identifiant">
					<Feature.Content>
						<PiecesJointesProvider>
							<SubventionFiche />
						</PiecesJointesProvider>
					</Feature.Content>
				</Feature>
				<Feature>
					<Feature.Content>
						<Segment
							inverted
							attached
							className="feature projetSubventionListe"
						>
							<Segment>
								<SubventionListeContainer />
							</Segment>
						</Segment>
					</Feature.Content>
				</Feature>
			</Menu>
			<Menu
				name="Planning"
				icon="calendar"
				path="/planning"
				dataTestId="ongletPlanning"
			>
				<Feature>
					<Feature.Content>
						<Segment inverted attached className="feature">
							<Segment>
								<AppPlanning timelineBoundaries />
							</Segment>
						</Segment>
					</Feature.Content>
				</Feature>
			</Menu>
			<SpeedDial>
				<SpeedDial.Button
					name="create_projet"
					icon="folder open"
					title="Créer un projet"
					path={`/projets/${newIdentifiant()}`}
					dataTestId="projetAjouter"
				/>
				<SpeedDial.Button
					name="create_subvention"
					icon="money-bill"
					title="Créer une subvention"
					path={`/subventionsPercues/${newIdentifiant()}`}
					dataTestId="subventionAjouter"
				/>
			</SpeedDial>
		</App>
	);
};
export default AppSubvention;
